import React from "react";
import { Link } from "../../lib/Link";

export const for_beginer = type => {
  return (
    <div className="for_beginer">
      <div className="message">
        <div className="title">初めての方へ</div>
        <div>最短３分！ＷＥＢ・電話でのお申込み</div>
      </div>
      <div className="collection">
        <Link className="item" to="/flow/#f1_1">
          <img src="resource/img/note.png" />
          <div>
            <span>お申し込みから</span>
            <span>ご契約までの流れ</span>
          </div>
        </Link>

        <Link className="item" to="/flow/#f1_2">
          <img src="resource/img/passport.png" />
          <div>ご契約に必要なもの</div>
        </Link>

        <Link className="item" to="/flow/#f1_3">
          <img src="resource/img/purses.png" />
          <div>お支払いについて</div>
        </Link>

        <Link className="item" to="/flow/#f1_4">
          <img src="resource/img/exclamation.png" />
          <div>ご契約時の注意事項</div>
        </Link>

        <Link className="item" to="/flow/#f1_5">
          <img src="resource/img/arms.png" />
          <div>保険について</div>
        </Link>
      </div>
      <Link to="/flow/" className="btn center black">
        一覧を見る
      </Link>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/top/for_beginer.jsx